import React from 'react';
import classNames from 'classnames';
import styles from './Table.module.less';
export var TableCell = function TableCell(_ref) {
  var children = _ref.children,
      className = _ref.className,
      colSpan = _ref.colSpan,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'td' : _ref$element,
      scope = _ref.scope,
      width = _ref.width;
  var Component = element; // Only `<th />` elements should be allowed scope
  // https://dequeuniversity.com/rules/axe/3.5/scope-attr-valid?application=axeAPI

  var canApplyScope = element === 'th';
  return /*#__PURE__*/React.createElement(Component, {
    className: classNames(styles[element], className),
    style: typeof width === 'number' ? {
      width: width
    } : undefined,
    scope: canApplyScope ? scope : undefined,
    colSpan: colSpan
  }, children);
};